import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/N - Logo.png';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Nexus Logo" className="logo" />
        </Link>
        
        <div className="menu-icon">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
        
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-links">
              Início
            </Link>
          </li>
          <li className="nav-item">
            <a 
              href="#sobre" 
              className="nav-links"
              onClick={(e) => {
                e.preventDefault();
                const sobreSection = document.getElementById('sobre');
                if (sobreSection) {
                  sobreSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Sobre
            </a>
          </li>
          <li className="nav-item">
            <Link to="/vip" className="nav-links">
              VIP
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/conta" className="nav-links">
              Conta
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
